import { useTranslation } from 'react-i18next'
import { LayerGroup, LayersControl } from 'react-leaflet'
import {
  MareanoKorallrevVernet,
  MareanoKorallrevObservert,
  MareanoKorallrevModellert,
  MareanoKorallrevIdentifisert,
} from '../MareanoLayers'

export const MareanoOverlayLayers: React.FC = () => {
  const { t } = useTranslation(['map', 'common'])
  return (
    <>
      <LayersControl.Overlay name={`<b><u>${t('biology-mareano', { defaultValue: 'Biologi - Mareano' })}</u></b>`}>
        <LayerGroup></LayerGroup>
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('coral-reef-protected', { defaultValue: 'Korallrev vernede' })}>
        <MareanoKorallrevVernet />
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('coral-reef-observed', { defaultValue: 'Korallrev observert' })}>
        <MareanoKorallrevObservert />
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('coral-reef-modelled', { defaultValue: 'Korallrev modellert' })}>
        <MareanoKorallrevModellert />
      </LayersControl.Overlay>
      <LayersControl.Overlay name={t('coral-reef-identified', { defaultValue: 'Korallrev identifisert' })}>
        <MareanoKorallrevIdentifisert />
      </LayersControl.Overlay>
    </>
  )
}
